import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InvoiceNoteDto } from 'src/app/dtos/invoice-note-dto.model';
import { Mode } from 'src/app/enums/mode.enum';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { ConfigService } from 'src/app/services/config.service';
import { ModeService } from 'src/app/services/mode.service';
import { OrderService } from 'src/app/services/order.service';
import { InvoiceNotesService } from 'src/app/services/invoice-notes.service';

@Component({
  selector: 'app-invoice-notes',
  templateUrl: './invoice-notes.component.html',
  styleUrls: ['./invoice-notes.component.css']
})
export class InvoiceNotesComponent implements OnInit {
  @Input() dialog = { show: false };
  @Output() newItemEvent = new EventEmitter<boolean>();
  readonly maxInvoiceNoteLength = 75;
  numOfLines = 5;
  Mode = Mode;
  isAddEditNote = false;
  isEditNote = false;
  showNotesError = false;
  myUserCode = '';
  nextNoteId = -1;
  isAuthorized = false;
  isSaveNote = false;
  isCloseOrderSaveNotes = false;
  selectedNote = new InvoiceNoteDto();
  currentNote = new InvoiceNoteDto();
  saveNewNote = false;
  // TODO: This property should be removed after the button is relocated outside the component.
  hasOnInitRun = false;
  // End of TODO

  constructor(
    private readonly invoiceNotesService: InvoiceNotesService,
    public readonly modeService: ModeService,
    private readonly configService: ConfigService,
    public readonly orderService: OrderService,
    private readonly authorizationService: AuthorizationService) {
  }

  async ngOnInit(): Promise<void> {
    this.myUserCode = this.configService.user.salesId;
    if(!this.orderService.orderDto.invoiceNoteDto){
      await this.getInvoiceNotes();
    }
    this.currentNote = this.orderService.orderDto.invoiceNoteDto!;
    console.log(this.currentNote);
    this.isAddEditNote = false;
    if(this.currentNote == null){
      this.selectedNote.createdDate = new Date();
      this.selectedNote.userCode = this.configService.user.salesId;
      this.selectedNote.userName = this.configService.user.fullName;
      this.selectedNote.orderId = this.orderService.orderDto.id;
      this.isAddEditNote = true;
      this.isAuthorized = true;
    }
    else{
      this.currentNote.userName = this.configService.getFullNameFromUserCode(this.currentNote.userCode);
      this.currentNote.orderId = this.orderService.orderDto.id; 
      this.isAddEditNote = false;
    }
    this.orderService.triggerEditMethod();
    this.orderService.lockOrderComplete?.subscribe(async () => {
      if(this.dialog.show){
        this.getInvoiceNotes();
      }
    });
    
  }

  async getInvoiceNotes(): Promise<void> {
    this.invoiceNotesService.invoiceNotesDto = await this.invoiceNotesService.getInvoiceNotes(this.orderService.orderDto.id);
    this.orderService.orderDto.invoiceNoteDto = this.invoiceNotesService.invoiceNotesDto;
    if(this.orderService.orderDto.invoiceNoteDto==null)
    {
      this.isAddEditNote = true;
    }
    else
    {
      this.isAddEditNote = false;
      if (this.configService.hasResource('OrderInquiryAdditionalActionsEditInvoiceNotes') && !this.orderService.orderStatus.toString().includes('Pending Shipment') ) 
        {
          this.orderService.orderDto.invoiceNoteDto.isEditEnabled = true;
        }
    }
    
  }

  closeDialog() {
    this.dialog.show = false;
    if (this.orderService.editWasTriggered && this.isSaveNote === false) {
      this.orderService.triggerRevertMethod();
    }
    else if (this.orderService.editWasTriggered  && this.isSaveNote === true) {
      this.orderService.triggerSaveMethod(false);
    }
    else if (this.isCloseOrderSaveNotes && this.isSaveNote === true){
      this.orderService.setLockOrder(this.orderService.orderDto.id, this.authorizationService.getMyMSId(), false).subscribe(
        (data) => {          
          this.orderService.triggerSaveMethod(true);
      });
    }

  }

  cancelDialog() {
    this.isAddEditNote = false;
    this.isEditNote = false;
    if(this.currentNote == null){
      this.dialog.show = false;
    }
  }
  onEdit(note: InvoiceNoteDto) {
    this.isAuthorized = false;
    this.isAddEditNote = true;
    this.isEditNote = true;
    this.selectedNote = ({
      noteText: note.noteText,
      userCode: note.userCode,
      id: note.id,
      orderId: note.orderId,
      createdDate: note.createdDate,
      isTruncated: false,
      userName: this.configService.getFullNameFromUserCode(note.userCode)
    } as InvoiceNoteDto)

    if (this.configService.hasResource('AdditionalActionsNotesSystemNoteText')
      || this.selectedNote.userCode === this.configService.user.salesId) {
      this.isAuthorized = true;
    }
  }

  noteTextChange(): void {
     if (this.selectedNote.noteText?.length > this.maxInvoiceNoteLength) {
      this.selectedNote.noteText = this.selectedNote.noteText.substring(0, this.maxInvoiceNoteLength);
    }
     this.showNotesError = !this.selectedNote.noteText;
  }

  saveNote(): void {
    if (!this.selectedNote.noteText) {
      this.showNotesError = true;
      return;
    }

    this.selectedNote.noteText = this.selectedNote.noteText.substring(0, this.maxInvoiceNoteLength);

    if(this.orderService.orderDto.invoiceNoteDto == null){
      this.saveNewNote = true;
    }
    this.isAddEditNote = false;
    this.isSaveNote = true;
    this.isEditNote = false;
    this.orderService.orderDto.invoiceNoteDto = this.selectedNote;
    this.currentNote = this.selectedNote;
  }
}
